import axios from 'axios';

export const getWizardPlans = async (client, hasClient) => {
  const generalApi = 'wizard/plans';
  const apiUrl = generalApi + (hasClient ? `?client=${client}` : '');
  const response = await axios.get(apiUrl);

  return response?.data;
};
